import React from 'react'

export default function VariableImage(props){
    return (
    <img src={props.Img} alt={props.altText}/>
    )
}

